export const ProductCategories = [
    "Breakfast",
    "Breads",
    "Salads - Core",
    "Salads - Optional",
    "LTO & Add Ons",
  ];

export const ZERO_ID = '00000000-0000-0000-0000-000000000000'